import React, { useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import { isRTL } from '../../../helpers/formatLocale';

import icon from '/public/SiteIcons/double-quotes.png';
import defaultPic from '/public/SiteImages/defaultPic.png';
import { SampleNextArrow, SamplePrevArrow } from '../../../helpers/swiper';

import cs from 'swiper/swiper-bundle.css';
import s from './PaymentContent.css';
import t from '../../../styles/customSwiper.css';

const PaymentContent = ({ data = [], reviewData }) => {
  const { locale } = useIntl();

  const [load, setLoad] = useState(false);
  const swiperRef = useRef(null);
  const timeoutRef = useRef(null);

  let Swiper, SwiperSlide, Navigation;

  if (typeof window !== 'undefined') {
    const swiperPackage = require('swiper/react');
    const swiperModule = require('swiper/modules');
    Swiper = swiperPackage.Swiper;
    SwiperSlide = swiperPackage.SwiperSlide;
    Navigation = swiperModule.Navigation;
  }

  useEffect(() => {
    setLoad(true);
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  useEffect(() => {
    setLoad(false);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setLoad(true);
    }, 3000);
  }, [locale]);

  const swiperParams = {
    modules: [Navigation],
    navigation: {
      nextEl: `.whyHostPageSwiperNextBtn`,
      prevEl: `.whyHostPageSwiperPrevBtn`,
    },
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 1,
      }
    }
  };

  return (
    <div className={s.container}>
      <div className={cx(s.mainhedding, 'mainheddingRTLMobile', 'whyHostSlider', 'whyHostSliderRTL')}>
        <h1>{data && data.paymentTitleHeading}</h1>
      </div>

      {load && Swiper && SwiperSlide && (
        <div>
          <Swiper {...swiperParams} rtl={isRTL(locale)} ref={swiperRef}>
            {reviewData.map((review, index) => {
              const image = review.image ? `/images/home/${review.image}` : defaultPic;
              return (
                <SwiperSlide key={index}>
                  <div className={cx(s.outline)}>
                    <div className="svgImg">
                      <img src={icon} className={s.iconCss} alt="quote" />
                    </div>
                    <div className={cx(s.content)}>{review.reviewContent}</div>
                    <div className={s.flex}>
                      <span>
                        <img src={image} className={s.imgCss} alt="user" />
                      </span>
                      <span className={cx(s.name, 'reviewNameRTL')}>{review.userName}</span>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          <div className={s.arrowCenter}>
            <SamplePrevArrow className="whyHostPageSwiperPrevBtn" />
            <SampleNextArrow className="whyHostPageSwiperNextBtn" />
          </div>
        </div>
      )}
    </div>
  );
};

export default withStyles(cs, s, t)(PaymentContent);